import { Tabs, TabsProps } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TEXT_BUTTON_HEADER_LIST } from '../../../config/config';
import { PermissionBanners } from '../../../permissions/PermissionBanners';
import { PermissionCategories } from '../../../permissions/PermissionCategories';
import { PermissionComponents } from '../../../permissions/PermissionComponents';
import bannerStore from '../../../stores/bannerStore';
import categoryStore from '../../../stores/categoryStore';
import componentsStore from '../../../stores/componentsStore';
import BreadCrumbComponent from '../../atoms/BreadCrumbComponent';
import NotPermissionComponent from '../../atoms/NotPermissionComponent';
import ContentBox from '../../molecules/ContentBox';
import LoadingComponent from '../../molecules/LoadingComponent';
import Permission from '../../molecules/Permission';
import { useAuth } from '../../protected/ProviderAuth';
import CreateComponentKernel from './CreateComponent';
import ListComponentsKernel from './ListComponentsKernel';
import ViewHomeFullKernel from './ViewHomeFull';

const breadCrumb = [
    {
        title: <Link to="/dashboard">Dashboard</Link>,
    },
    {
        title: <p>Cadastro de Home</p>,
    },
]

const CreateHomeKernel: React.FC = observer(() => {
    const navigate = useNavigate();
    const [activeTabKey, setActiveTabKey] = useState('1');
    const [isMobile, setMobile] = useState<boolean>(false);
    const { hasPermission } = useAuth();
    const { loading } = componentsStore;

    const listRouter = () => {
        navigate(`/componentes`);
    }

    const defaultparamsChannel = {
        size: 99999,
        page: 0,
        sort: 'created,desc',
        search: '',
    }

    useEffect(() => {
        const paramsDefault = {
            "size": 20,
            "page": 0,
            "sort": "created,desc",
            "search": ""
        }

        const fetchData = async () => {
            await componentsStore.getList(paramsDefault);
        };
        fetchData();
    }, []);


    useEffect(() => {
        if (hasPermission(PermissionBanners.GET)) {
            bannerStore.getList(defaultparamsChannel);
        }

        if (hasPermission(PermissionCategories.GET)) {
            categoryStore.getList();
        }
    }, [])

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Cadastrar Componente',
            children: <CreateComponentKernel />,
        },
        {
            key: '2',
            label: 'Componentes Cadastrados',
            children: <ListComponentsKernel />,
        },
        {
            key: '3',
            label: 'Preview Home',
            children: <ViewHomeFullKernel setMobile={setMobile} isMobile={isMobile} />,
        },
    ];


    const onChange = (key: string) => {
        setActiveTabKey(key);
    };

    return (
        <>
            <BreadCrumbComponent breadCrumbList={breadCrumb} permission={PermissionComponents.GET} textButton={TEXT_BUTTON_HEADER_LIST} onClick={() => listRouter()} />

            {loading ? (
                <ContentBox className="mb-4 p-6" title="Cadastro de Produto" description="Tela para cadastro de Produto">
                    <LoadingComponent />
                </ContentBox>
            ) : (
                <Permission
                    permissionKeys={[PermissionComponents.POST, PermissionComponents.PUT, PermissionComponents.GET_UUID]}
                    fallback={NotPermissionComponent()}
                >
                    <Tabs
                        className="mb-0"
                        type="card"
                        activeKey={activeTabKey}
                        onChange={onChange}
                        items={items}
                    />
                </Permission>
            )}
        </>
    );
});

export default CreateHomeKernel;